import { useContext } from 'react';
import { TeamContext } from 'src/context/team-context';

import { Team } from '@chaos/types';

export const useTeams = (): Team[] | undefined => {
  const { teams } = useContext(TeamContext);
  return teams;
};
